import { Link } from "react-router-dom";
import styled from "styled-components";
import { media } from "../styles/breakpoints";
import { font } from "../styles/typography";

const AuthBlockStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

const ProfileLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: var(--spark-color-text);
  cursor: pointer;

  &:hover {
    color: var(--spark-color-brand);
  }
`;

const AvatarCircle = styled.div`
  width: ${(p) => p.$size || 32}px;
  height: ${(p) => p.$size || 32}px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--spark-color-on-brand);
  background: var(--spark-color-brand);
  user-select: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const UserName = styled.span`
  font-size: 14px;
  white-space: nowrap;

  ${media.tablet`
    display: none;
  `}
`;

const AdminIconLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--spark-color-text-muted);
  text-decoration: none;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: var(--spark-color-brand);
    background: var(--spark-color-action-hover-surface);
  }
`;

const LogoutLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--spark-color-text-muted);
  text-decoration: none;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: var(--spark-color-error-text);
    background: var(--spark-color-error-surface);
  }
`;

const SwitchUserBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--spark-color-text-muted);
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  padding: 0;

  &:hover {
    color: var(--spark-color-info-text);
    background: var(--spark-color-info-surface);
  }
`;

// Группа Admin/Switch/Logout иконок в inline-режиме — на мобильных прячется,
// эти действия переезжают в MenuItemLink/MenuItemButton мобильной панели.
const InlineIconsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${media.tablet`
    display: none;
  `}
`;

const MenuUserCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
`;

const MenuUserInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

const MenuUserName = styled.div`
  font-weight: 600;
  ${font('base')}
  color: var(--spark-color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MenuUserEmail = styled.div`
  ${font('sm')}
  color: var(--spark-color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MenuRoleBadge = styled.span`
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--spark-color-action-hover-surface);
  color: var(--spark-color-brand);
  font-size: 11px;
  font-weight: 600;
`;

const MenuDivider = styled.div`
  border-top: 1px solid var(--spark-color-border);
  margin: 4px 0;
`;

const menuItemStyles = `
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 12px 24px;
  background: none;
  border: none;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
`;

const MenuItemLink = styled(Link)`
  ${menuItemStyles}
  ${font('base')}
  color: ${(p) => (p.$danger ? 'var(--spark-color-error-text)' : 'var(--spark-color-text)')};

  svg {
    flex-shrink: 0;
    color: ${(p) => (p.$danger ? 'var(--spark-color-error-text)' : 'var(--spark-color-text-muted)')};
  }

  &:hover {
    background: ${(p) => (p.$danger ? 'var(--spark-color-error-surface)' : 'var(--spark-color-surface-muted)')};
  }
`;

const MenuItemButton = styled.button`
  ${menuItemStyles}
  ${font('base')}
  color: var(--spark-color-text);

  svg {
    flex-shrink: 0;
    color: var(--spark-color-text-muted);
  }

  &:hover {
    background: var(--spark-color-surface-muted);
  }
`;

export {
  AuthBlockStyled,
  ProfileLink,
  AvatarCircle,
  UserName,
  AdminIconLink,
  LogoutLink,
  SwitchUserBtn,
  InlineIconsGroup,
  MenuUserCard,
  MenuUserInfo,
  MenuUserName,
  MenuUserEmail,
  MenuRoleBadge,
  MenuDivider,
  MenuItemLink,
  MenuItemButton,
};
